import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { getDeviceId } from "@/lib/fingerprint";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const nav = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const params = new URLSearchParams(hash.replace(/^#/, ""));
    const sessionId = params.get("session_id");

    if (!sessionId) {
      toast.error("Sign-in failed. Please try again.");
      nav("/login", { replace: true });
      return;
    }

    (async () => {
      try {
        const res = await api.post("/auth/google", {
          session_id: sessionId,
          device_id: getDeviceId(),
        });
        localStorage.setItem("cf_token", res.data.token);
        setUser(res.data.user);
        // Clear the fragment so refreshing doesn't retry
        window.history.replaceState(null, "", "/dashboard");
        toast.success(res.data.is_new ? `Welcome, ${res.data.user.name || res.data.user.email}` : "Welcome back");
        nav("/dashboard", { replace: true });
      } catch (err) {
        toast.error(err?.response?.data?.detail || "Google sign-in failed");
        nav("/login", { replace: true });
      }
    })();
  }, [nav, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center mesh-bg" data-testid="auth-callback">
      <div className="text-center">
        <div className="w-10 h-10 border-2 border-emerald-500 border-t-transparent rounded-full animate-spin mx-auto" />
        <p className="mt-4 text-zinc-400 text-sm font-mono uppercase tracking-widest">Signing you in…</p>
      </div>
    </div>
  );
}
